module.exports = __webpack_public_path__ + "7a314df72742ddaf36218acb1bc6ef5b.svg";